import { lazy, Suspense } from 'react'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'

const StorefrontPage = lazy(() =>
  import('@/pages/Storefront/StorefrontPage').then(m => ({ default: m.StorefrontPage }))
)

interface SubdomainStorefrontProps {
  slug: string
}

/**
 * Wrapper component used by the subdomain router.
 * Renders the StorefrontPage with a slug derived from the hostname
 * rather than from URL params.
 */
export function SubdomainStorefront({ slug }: SubdomainStorefrontProps) {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center min-h-[60vh]">
          <LoadingSpinner size="lg" />
        </div>
      }
    >
      <StorefrontPage slugOverride={slug} />
    </Suspense>
  )
}
